import { render, staticRenderFns } from "./GridSelector.vue?vue&type=template&id=84d536fc&scoped=true"
import script from "./GridSelector.vue?vue&type=script&lang=js"
export * from "./GridSelector.vue?vue&type=script&lang=js"
import style0 from "./GridSelector.vue?vue&type=style&index=0&id=84d536fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d536fc",
  null
  
)

export default component.exports